import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../api/axios';
import FormattedJsonDisplay from './FormattedJsonDisplay';
import QADisplay from './QADisplay';

function History() {
    const [conversations, setConversations] = useState([ ]);

    const getHistory = async () => {    
        const sessionId = localStorage.getItem('sessionId');    
        try {
          // Replace with your Dialogflow API endpoint
          const response = await axiosInstance.get('/conversations', {
            session_id: sessionId
          });
    
          const conversations = response.data.conversations;
          if (conversations) {
            setConversations(conversations);
          }
        } catch (error) {
          console.error('Error sending message:', error);
        }
      };

    useEffect(() => {
        getHistory();
      }, []);

      return (
        <div className="w-full max-w-4xl mx-auto bg-white rounded-lg shadow-lg border border-gray-200">
          <div className="h-[500px] overflow-y-auto p-4">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Session ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Intent</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Chat</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {conversations.map((conversation, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{conversation.id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{conversation.session_id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"><FormattedJsonDisplay data={JSON.stringify(conversation.last_intent)} /></td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      <div className="max-w-xs break-words"><QADisplay data={JSON.stringify(conversation.chats)} /></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );



      
}
export default History;